import {
  USER_AI_MESSAGE_VACANCY_ACTION_NAMES,
  type UserAiMessageAction,
} from '@entities/user';

export type VacancyLinkFromAction = {
  id: number;
  name: string;
  url?: string | null;
};

export const getVacancyButtonsFromActions = (
  actions?: UserAiMessageAction | null
): { id: number; label: string }[] =>
  actions?.interactiveElements?.flatMap(element => {
    const id = element.action?.vacancyId;
    const label = element.label?.trim();

    if (
      element.type !== 'button' ||
      element.action?.type !== 'open_vacancy' ||
      id == null ||
      !Number.isInteger(id) ||
      id <= 0 ||
      !label
    ) {
      return [];
    }

    return [{ id, label }];
  }) ?? [];

const isVacancyAction = (
  actions: UserAiMessageAction
): actions is UserAiMessageAction & {
  name: (typeof USER_AI_MESSAGE_VACANCY_ACTION_NAMES)[number];
} => actions.name === 'vacancy_created' || actions.name === 'vacancy_edited';

export const isVacancyActionMessage = (
  actions?: UserAiMessageAction | null
): actions is UserAiMessageAction & {
  name: (typeof USER_AI_MESSAGE_VACANCY_ACTION_NAMES)[number];
} => actions != null && isVacancyAction(actions);

export const getVacancyLinkFromActions = (
  actions?: UserAiMessageAction | null
): VacancyLinkFromAction | null => {
  if (!isVacancyActionMessage(actions)) {
    return null;
  }

  const vacancy = actions.data?.vacancy;
  const id = vacancy?.id;
  const name = vacancy?.name;

  if (id == null || !name) {
    return null;
  }

  return {
    id,
    name,
    url: vacancy.url,
  };
};
